module.exports = __webpack_public_path__ + "public/files/img/health.cf5f71f0.png";